import React, { ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomIcon, { AssetTypes } from "../../../../../public/icons-v1_1";
import {
  BADGE_COLORS,
  PathPickBadgeColorVariant,
} from "@/features/pathpick/components/ui/PathPickBadge";

interface Props {
  // 배지와 같은 팔레트를 쓴다 — red는 실패, yellow는 선행 조건 안내.
  tone: PathPickBadgeColorVariant;
  // 이미 번역된 본문 (i18n 키를 받지 않는다)
  children: ReactNode;
  // 굵은 첫 줄 — 원인과 조치를 나눠 적어야 할 때만 쓴다.
  title?: string;
  // 본문 왼쪽 아이콘 (예: warning-triangle, info-circle)
  leadingIcon?: AssetTypes;
  // 오른쪽에 붙는 조치 버튼 슬롯 (예: [다시 시도])
  action?: ReactNode;
}

// 섹션 안에서 한 줄로 알리는 안내/에러 박스.
// 같은 마크업이 화면마다 흩어지지 않도록 한 곳에 모았다.
function PathPickInlineNotice({
  tone,
  children,
  title,
  leadingIcon,
  action,
}: Props) {
  const colors = BADGE_COLORS[tone];

  return (
    <Flex
      // 아이콘 색은 여기서 currentColor로 상속시킨다 (CustomIcon에 color를 넘기지 않는다)
      color={colors.color}
      gap={"12px"}
      alignItems={"center"}
      justifyContent={"space-between"}
      padding={"12px"}
      borderRadius={"8px"}
      border={`0.5px solid ${colors.borderColor}`}
      background={colors.background}
    >
      <Flex gap={"8px"}>
        {leadingIcon && (
          // 본문이 여러 줄로 접혀도 아이콘은 첫 줄에 붙어 있어야 한다.
          <Flex flexShrink={0} alignSelf={"flex-start"} paddingTop={"1px"}>
            <CustomIcon src={leadingIcon} width={16} height={16} />
          </Flex>
        )}
        <Flex flexDirection={"column"} gap={"4px"}>
          {title && (
            <Text textStyle={"body-sm-bold"} color={colors.color}>
              {title}
            </Text>
          )}
          <Text textStyle={"body-sm-medium"} color={colors.color}>
            {children}
          </Text>
        </Flex>
      </Flex>
      {action && <Flex flexShrink={0}>{action}</Flex>}
    </Flex>
  );
}

export default PathPickInlineNotice;
